import { useTheme } from '../../ThemeContext';

export default function FormLabel({ children, htmlFor }) {
  const { t } = useTheme();

  return (
    <label
      htmlFor={htmlFor}
      style={{
        fontSize: '13px',
        fontWeight: '500',
        color: t.text,
        display: 'block',
        marginBottom: '6px',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      {children}
    </label>
  );
}
